import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=08fdbc42&scoped=true&"
import script from "./StudentsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTable.vue?vue&type=style&index=0&id=08fdbc42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fdbc42",
  null
  
)

export default component.exports